import { MiBox, MiList } from "@miplatform/components";
import { PAGINATION } from "@miplatform/constants";
import { useRouter } from "@miplatform/hooks";
import { formatDate } from "@miplatform/utils";
import { usePlanCommunitiesViewModel } from "./usePlanCommunitiesViewModel";

export function PlanCommunities({ stateManager, debouncedSearch }) {
  const {
    navigate,
    params: { accountId, tab },
  } = useRouter();
  const { isLoading, communities, setCommunities, getCommunities } =
    usePlanCommunitiesViewModel({
      stateManager,
      accountId,
      debouncedSearch,
    });

  const sections = [
    {
      fieldset: [
        {
          label: "Name",
          field: "name",
        },
        {
          label: "Applied Bids",
          field: "appliedPlans",
        },
        {
          label: "Created Date",
          field: "createdOn",
          renderValue: ({ createdOn }) =>
            formatDate(createdOn, "ddd, MMMM D, YYYY"),
        },
      ],
    },
  ];

  const handleNavigate = (item) => {
    navigate(`/estimating/old-bids/${accountId}/${tab}/${item.id}/all-bids`);
  };

  return (
    <MiBox>
      <MiList
        viewType="card"
        showRecent
        data={communities}
        setData={setCommunities}
        dataProvider={getCommunities}
        paginationMode={PAGINATION.SERVER}
        search={debouncedSearch}
        loading={isLoading}
        cardProps={{
          sections,
          onClick: (item) => handleNavigate(item),
        }}
        emptyListProps={{
          text: "No Communities found",
        }}
        data-testid="plan-communities-list"
      />
    </MiBox>
  );
}
